module.exports = __webpack_public_path__ + "img/undraw_Online_world_re_h4cb.8f28ac94.svg";